import { createUseStyles } from 'react-jss';
export const useLiveChatDraggHandlerStyles = createUseStyles({
    '@keyframes fadeIn': {
        '0%': {
            opacity: 0,
        },
        '35%': {
            opacity: 0,
        },
        '100%': {
            opacity: 1,
        },
    },
    'livechat-dragg-handler': {
        position: 'absolute',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
        height: '28px',
        top: '28px',
        alignItems: 'center',
        opacity: 0,
        animation: `$fadeIn 0.7s forwards`,
        userSelect: 'none',
    },
    'livechat-dragg-handler-icon': ({ theme }) => ({
        animation: `$fadeIn 0.7s forwards`,
        background: 'white',
        color: theme.colors.silver,
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'auto',
        width: '30%',
        '&:hover': {
            color: 'black',
        },
        '&:focus': {
            cursor: 'move',
        },
    }),
});
